import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useStylesMUI } from '../../../../styles/home/style';
import { TempABM } from '../../../atomic/templates/TempABM';
import { ValidatorInputField } from '../../../atomic/atoms/Inputs';
import { required } from '../../../../helpers/validations/validators';
import { deleteTipoDocumentacionIntegracion, getAllTiposDocumentacionIntegracion, guardarTipoDocumentacionIntegracion } from '../../../../actions/discapacidad/discapacidadActions';

export const TipoDocumentacionIntegracionAbm = () => {
    const dispatch = useDispatch();
    const classes = useStylesMUI();

    const { tiposDocumentacion } = useSelector(state => state.discapacidad);

    useEffect(() => {
        dispatch(getAllTiposDocumentacionIntegracion());
    }, []);

    return (
        <div className={classes.root}>
            <TempABM
                gridProps={{ md: 8 }}
                tableProps={{
                    sizeTableCells: ["20%", "50", "20%"]
                }}
                titles={{
                    abm: 'Tipo Documentación Integración',
                    insert: 'Agregar Tipo Documentación',
                    update: 'Modificar Tipo Documentación',
                    delete: 'Eliminar Tipo Documentacion',
                    deleteMsg: 'Desea Eliminar este Tipo de Documentacion',
                }}
                data={(data) => ({
                    idTipoDoc: data?.idTipoDoc || '',
                    descripcion: data?.descripcion || '',
                })}
                formStructure={({ formValues, handleInputChange }) => [
                    {
                        Component: (
                            <ValidatorInputField
                                variant="outlined"
                                label="Descripción"
                                name="descripcion"
                                value={formValues.descripcion}
                                onChange={handleInputChange}
                                validations={[required]}
                            />
                        ),
                    }
                ]}
                dataTable={{
                    list: tiposDocumentacion.map(item => ({...item, id: item.idTipoDoc})),
                    columns: [
                        {
                            label: 'Descripcion',
                            id: 'descripcion',
                        },
                    ],
                }}
                submit={(formValues, handleClose) => {
                    dispatch(guardarTipoDocumentacionIntegracion(formValues, handleClose));
                }}
                deleteButton={(id, handleClose) => {
                    dispatch(deleteTipoDocumentacionIntegracion(id, handleClose));
                }}
            />
        </div>
    );
};
